import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function useResource(resource, extraParams = {}) {
  const { brand } = useApp();
  const qc = useQueryClient();
  const params = { ...extraParams };
  if (brand && brand !== "All brands") params.brand = brand;

  const query = useQuery({
    queryKey: [resource, brand, extraParams],
    queryFn: async () => (await api.get(`/resource/${resource}`, { params })).data,
  });

  const create = useMutation({
    mutationFn: (body) => api.post(`/resource/${resource}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: [resource] }),
  });

  const update = useMutation({
    mutationFn: ({ id, body }) => api.patch(`/resource/${resource}/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: [resource] }),
  });

  const remove = useMutation({
    mutationFn: (id) => api.delete(`/resource/${resource}/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: [resource] }),
  });

  return { ...query, items: query.data || [], create, update, remove };
}

export function useDashboard() {
  const { brand } = useApp();
  return useQuery({
    queryKey: ["dashboard", brand],
    queryFn: async () => (await api.get("/dashboard", { params: brand !== "All brands" ? { brand } : {} })).data,
  });
}
